import {
  CHANGE_PAGE,
  JAVASCRIPT_PAGE,
  PYTHON_PAGE,
  HOME_PAGE,
  CSS_PAGE,
  REACT_PAGE,
  FETCH_BLOGS_SUCCESS,
  ARTICLE_PAGE
} from "../constants/action-types";
import { createClient } from "contentful";

// goes to javascript page
export function doGoToJavascriptPage() {
  return {
    type: CHANGE_PAGE,
    payload: {
      url: JAVASCRIPT_PAGE
    }
  };
}

// goes to python tricks page
export function doGoToPythonPage() {
  return {
    type: CHANGE_PAGE,
    payload: {
      url: PYTHON_PAGE
    }
  };
}

// goes to home page
export function doGoToHomePage() {
  return {
    type: CHANGE_PAGE,
    payload: {
      url: HOME_PAGE
    }
  };
}

// goes to css page
export function doGoToCSSPage() {
  return {
    type: CHANGE_PAGE,
    payload: {
      url: CSS_PAGE
    }
  };
}

// goes to react page
export function doGoToReactPage() {
  return {
    type: CHANGE_PAGE,
    payload: {
      url: REACT_PAGE
    }
  };
}

// goes to an article of specific id
export function doGoToArticle(id) {
  return {
    type: CHANGE_PAGE,
    payload: {
      url: ARTICLE_PAGE,
      id
    }
  };
}

// updates state based on the url
export function doUpdateUrl(pathname) {
  let [path, id] = pathname.slice(1).split("$");
  switch (path) {
    case ARTICLE_PAGE:
      return {
        type: CHANGE_PAGE,
        payload: {
          url: ARTICLE_PAGE,
          id
        }
      };
    default:
      return {
        type: CHANGE_PAGE,
        payload: {
          url: path || HOME_PAGE
        }
      };
  }
}

// gets blogs from backend
export function fetchBlogs() {
  return dispatch => {
    var client = createClient({
      space: "r9859cd2aq53",
      accessToken:
        "5a741a743921f1b02c316f05649efaa818bb1fef5f428a05ab8aa1295e3b59dc"
    });
    return client.getEntries().then(r => {
      dispatch(fetchBlogsSucess(r.items));
      return r.items;
    });
  };
}

const fetchBlogsSucess = blogs => ({
  type: FETCH_BLOGS_SUCCESS,
  payload: { blogs }
});
